import PropTypes from 'prop-types';
import React from 'react';
import TreeView from 'react-treeview';
import { BoxIcon } from '../icons/BoxIcon.jsx';
import styles from './GroupsTree.module.css';

const groupPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  parentId: PropTypes.number,
});

groupPropTypes.children = PropTypes.arrayOf(groupPropTypes);

GroupsTree.propTypes = {
  rootLabel: PropTypes.string.isRequired,
  groups: PropTypes.arrayOf(groupPropTypes).isRequired,
};

function NodeLabel({ children, showOutlineBox }) {
  return (
    <span>
      <BoxIcon showOutline={showOutlineBox} />
      <strong className={styles.strong}>{children}</strong>
    </span>
  );
}

function renderNode({ children, id, name }) {
  if (children.length === 0) {
    return (
      <div className="tree-view_leaf" key={id}>
        <NodeLabel>{name}</NodeLabel>
      </div>
    );
  }

  const nodeLabel = <NodeLabel>{name}</NodeLabel>;

  return (
    <TreeView key={id} nodeLabel={nodeLabel}>
      {children.map(renderNode)}
    </TreeView>
  );
}

function GroupsTree({ groups, rootLabel }) {
  const rootNodeLabel = <NodeLabel showOutlineBox>{rootLabel}</NodeLabel>;

  return (
    <TreeView nodeLabel={rootNodeLabel}>{groups.map(renderNode)}</TreeView>
  );
}

export default GroupsTree;
